import adminNavigation from 'components/sidebar/sidebar-admin-navigation';
import { getUserNavigation } from 'components/sidebar/sidebar-user-navigation';
import { UploadeImageInterface } from 'interfaces/heatmap.interface';
import { ImageSizes, ResizedImage } from 'interfaces/resize-image.interface';
import { AmazonApiTypes, AmazonQueryParamsInterface } from 'pages/users/amazon/amazon.interface';
import { store } from 'redux/store';
import { postFetch } from 'request/request';
import { postFetch as postFetchApi } from 'request/request-api';
import { validationError } from 'request/request.slice';
import { globalConfig, uploadsErrorMessage } from 'lib/global-config';
import { SidebarGroupedNavigationInterface } from 'components/sidebar/navigation.interface';

/**
 * get amazon type by url segment
 */
export function getAmazonApiType(prefix = 'login-redirect'): AmazonApiTypes {
  const url = window.location.href;
  return url.includes(`/${prefix}/ads?`) ? AmazonApiTypes.ADS : AmazonApiTypes.SP;
}

export function getAllQueryString(): AmazonQueryParamsInterface {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries());
}

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export const dateToTime = (date) => date.toLocaleString('en-US');

export const localDate = (date) => dateToTime(new Date(date));

export function showComponent(show, component) {
  return show ? component : null;
}

export function getImage(asin) {
  return (
    'https://ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=' +
    asin +
    '&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=SL250'
  );
}

/**
 * snakeCase to Capitalized Words
 * eg: firstName = First Name, homeFirstName = Home First Name
 * @param string
 */
export function snakeToCapitalize(string) {
  return string
    .replace(/([A-Z])/g, function (match) {
      return ' ' + match;
    })
    .replace(/^./, function (match) {
      return match.toUpperCase();
    });
}

export const get = (object, path) => {
  return path
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .split('.')
    .reduce((o, k) => (o || {})[k], object);
};

/**
 * redirect users if on product, otherwise alert the URL (dev use)
 * @param url - redirect url
 */
export function alertOrRedirect(url) {
  return (window.location.href = url);
}

export const defaultHeatmapImage = '/placeholder.jpeg';

export function getImageSize(image: ResizedImage[] | undefined, width: ImageSizes): string {
  if (image && image.length > 0) {
    const imageUrl = image.find((i) => i.width === width);

    return imageUrl ? imageUrl.image : defaultHeatmapImage;
  } else {
    return defaultHeatmapImage;
  }
}

export function getHeatmapCoverImage(group): string {
  if (group.coverGrid) {
    // todo generate image based on array of image urls
  }
  return '/placeholder.jpeg';
}

export const fallbackImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==';

export const featuresImage =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjEwIiBmaWxsPSIjRDZGQUNGIi8+PHBhdGggZmlsbD0iIzI0QjQ3RSIgZD0iTTEzLjUwNCA1Ljc1bC01LjI2MSA1LjEzNC0xLjQxNi0xLjYwN2MtLjYyNC0uNTE0LTEuNjA1LjA4NS0xLjE1OS44NTZsMS42ODIgMi44MDVjLjI2Ny4zNDMuODkzLjY4NSAxLjUxNyAwIC4yNjYtLjM0MyA1LjM1LTYuNDIgNS4zNS02LjQyLjYyNS0uNjg0LS4xNzgtMS4yODMtLjcxMy0uNzd2LjAwMXoiLz48L2c+PC9zdmc+';

/**
 * returns the size of the file in MB
 */
export function getFileSizeMB(size: number): number {
  return size / 1024 / 1024;
}

export function isBiggerThan(size: number, max): boolean {
  return getFileSizeMB(size) > max;
}

export const copyUrl = (url: string) => {
  navigator.clipboard.writeText(url); // Copy to clipboard
};

export const defaultPage = (roles, isAdmin = false) => {
  const navigation: SidebarGroupedNavigationInterface[] = isAdmin ? adminNavigation() : getUserNavigation(roles);
  for (const role of navigation) {
    for (const subMenu of role.subMenu) {
      if (subMenu?.id === 'ppcai' && role.subMenu.length === 1) return subMenu.href;
      else if (subMenu?.id !== 'ppcai') return subMenu.href;
    }
  }
};

export const handleUploadImage = async (
  formData: FormData,
  file: File,
  url: string,
  cb: (uploadedData: UploadeImageInterface) => void,
  error?: (err: string) => void
) => {
  if (!isBiggerThan(file.size, globalConfig.maxFileUpload)) {
    const uploadedData: UploadeImageInterface = await postFetch(url, formData, 'Uploaded Successfully!');
    cb(uploadedData);
  } else {
    error?.(uploadsErrorMessage);
    store.dispatch(validationError({ message: uploadsErrorMessage }));
  }
};
export const handleUploadImageMultiple = async (
  data: FormData,
  files: File[],
  url: string,
  cb: (uploadedData: UploadeImageInterface) => void,
  isAdmin = false
) => {
  const uploadedData = await postFetchApi({ url, data, saveMessage: 'Uploaded Successfully!', isAdmin });
  if (!uploadedData) {
    store.dispatch(validationError({ message: uploadsErrorMessage }));
  } else {
    cb(uploadedData);
  }
};

export const optionFormat = (value) => {
  return value.region + '/' + value.id;
};

export function showObject(obj): boolean {
  return obj !== undefined && obj !== null && Object.keys(obj).length > 0;
}

export function formatArrayToAnd(arr) {
  if (arr.length === 1) {
    return arr[0];
  } else if (arr.length === 2) {
    return arr.join(' and ');
  } else {
    const formattedString = arr.slice(0, arr.length - 1).join(', ');
    return formattedString + ', and ' + arr[arr.length - 1];
  }
}

export function cleanArray(arr) {
  const cleanedArray = arr.filter((str) => str && str.trim() !== '');
  return cleanedArray;
}
